// src/slices/job/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Get All Jobs
export const getJobs = createAsyncThunk("job/getAll", async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/job/all`, { params: { page, limit } });

    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: "Failed to fetch jobs" });
  }
});
// Get Single Job By Identifier
export const getJobByIdentifier = createAsyncThunk("job/getByIdentifier", async (identifier, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/job/one/?identifier=${identifier}`);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: "Failed to fetch job" });
  }
});
export const createJob = createAsyncThunk("job/create", async (data, { rejectWithValue }) => {
  try {
    const payload = { ...data };

    // delete payload.image;

    const response = await axios.post(`${API_URL}/job/from-user`, payload, { headers: { "Content-Type": "application/json" } });

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Error creating job");
  }
});
export const addJob = createAsyncThunk("job/add", async (payload, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/job/from-user`, payload, { headers: payload instanceof FormData ? { "Content-Type": "multipart/form-data" } : { "Content-Type": "application/json" } });

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
export const createJobApplication = createAsyncThunk("jobApplication/create", async (payload, { rejectWithValue }) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");


    const response = await axios.post(`${API_URL}/job-application`, payload, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });


    return response.data;
  } catch (error) {
    console.error("Job Application Error:", error.response?.data || error.message);

    return rejectWithValue(error.response?.data || error.message);
  }
});
